import { useWalletAuth } from '@/hooks/useWalletAuth'
import { Button, Text, View } from 'reshaped'
import styles from '../Splash/Splash.module.css'
import { SplashVideo } from '../Splash/SplashVideo'
import { ZoraLogo } from '../ZoraLogo/ZoraLogo'

export function NoAllocation() {
  const { login } = useWalletAuth()

  return (
    <View className={styles.app}>
      <View
        position="fixed"
        insetTop={0}
        insetBottom={0}
        insetStart={0}
        insetEnd={0}
        width="100vw"
        height="100vh"
        zIndex={1}
        attributes={{
          style: {
            pointerEvents: 'none',
          },
        }}
      >
        <SplashVideo />
      </View>

      <View className={styles.content}>
        <View
          className={styles.logo}
          justify="center"
          align="center"
          width="100%"
          maxWidth="100%"
        >
          <ZoraLogo />
        </View>

        <View position="relative" width="100%" maxWidth="487px">
          <View
            position="absolute"
            backgroundColor="page"
            borderRadius="xlarge"
            zIndex={5}
            width="100%"
            height="100%"
            insetTop={0}
            insetStart={0}
            attributes={{
              style: {
                boxShadow:
                  '0px 0px 40px 0px #FFF, 0px 0px 20px 0px #FFF, 0px 0px 20px 0px #FFF, 0px 0px 20px 0px #FFF, 0px 0px 40px 0px #FFF, 0px 0px 20px 0px #FFF, 0px 0px 100px 0px #FFF',
                backdropFilter: 'blur(0.5px)',
              },
            }}
          />

          <View
            direction="column"
            align="center"
            gap={7}
            zIndex={6}
            padding={4}
            position="relative"
          >
            <Button
              variant="solid"
              color="primary"
              size="xlarge"
              onClick={login}
              className={styles.metallicButton}
              attributes={{
                style: {
                  pointerEvents: 'auto',
                  width: '100%',
                  maxWidth: '388px',
                  height: '60px',
                },
              }}
            >
              <Text variant="featured-3" weight="semibold" color="primary">
                Try another wallet
              </Text>
            </Button>

            <Text variant="body-3" weight="regular" color="primary">
              No $ZORA available for this wallet
            </Text>
          </View>
        </View>
      </View>
    </View>
  )
}
